import {Injectable} from '@angular/core';
import {BaseModelService} from '../../base-model.service';

@Injectable({
  providedIn: 'root'
})
export class MiseEnPlaceModelService extends BaseModelService {

  tableName = 'yu_v3_mise_en_place';

}
